import type { KeyboardEvent, Ref } from 'react';

import { InputField as InputFieldTwo } from '@proton/components/components/v2/field/InputField';

import { EasyTrans } from '../../../../../helpers/easyTrans';
import { MailImportPayloadError } from '../../../../../interface';

interface Props {
    disabled: boolean;
    errors: MailImportPayloadError[];
    handleChange: (val: any) => void;
    handleSave: () => void;
    hasError: boolean;
    inputRef: Ref<any>;
    inputValue: string;
    isLabelMapping: boolean;
}

const ManageFolderRowInput = ({
    disabled,
    errors,
    handleChange,
    handleSave,
    hasError,
    inputRef,
    inputValue,
    isLabelMapping,
}: Props) => {
    const trans = EasyTrans.get(isLabelMapping);

    let error;

    const tooLongErrors = [MailImportPayloadError.FOLDER_NAMES_TOO_LONG, MailImportPayloadError.LABEL_NAMES_TOO_LONG];

    if (tooLongErrors.some((error) => errors.includes(error))) {
        error = trans.errorNameTooLong();
    }

    if (errors.includes(MailImportPayloadError.UNAVAILABLE_NAMES)) {
        error = trans.errorNameAlreadyExists();
    }

    if (errors.includes(MailImportPayloadError.EMPTY)) {
        error = trans.errorEmptyValue();
    }

    if (errors.includes(MailImportPayloadError.RESERVED_NAMES)) {
        error = trans.errorReservedName();
    }

    return (
        <InputFieldTwo
            autoFocus
            disabled={disabled}
            required
            ref={inputRef}
            value={inputValue}
            onChange={handleChange}
            onKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    if (hasError) {
                        return;
                    }
                    handleSave();
                }
            }}
            dense
            error={error}
            className="h-auto"
        />
    );
};

export default ManageFolderRowInput;
